// extracted by mini-css-extract-plugin
export default {"tick":"Oa4OSRscp9aa1KQo5qfr"};